import { Dialog as DialogPrimitive } from "radix-ui";
import type { ComponentProps } from "react";

export const SheetTrigger = (props: ComponentProps<typeof DialogPrimitive.Trigger>) => (
  <DialogPrimitive.Trigger data-slot="sheet-trigger" {...props} />
);
